import { render, staticRenderFns } from "./modalUpgradableSubscription.vue?vue&type=template&id=519461de&scoped=true"
import script from "./modalUpgradableSubscription.vue?vue&type=script&lang=js"
export * from "./modalUpgradableSubscription.vue?vue&type=script&lang=js"
import style0 from "./modalUpgradableSubscription.vue?vue&type=style&index=0&id=519461de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519461de",
  null
  
)

export default component.exports